import auth from '../../api/auth'

// Authentication store
// Handles storage and management (login/logout) of authentication tokens
export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('token')
  },
  mutations: {
    updateToken (state, newToken) {
      localStorage.setItem('token', newToken)
      state.token = newToken
    },
    removeToken (state) {
      localStorage.removeItem('token')
      state.token = null
    }
  },
  actions: {
    login ({commit}, params) {
      return new Promise((resolve, reject) => {
        auth.login({
          email: params.email,
          password: params.password
        },
        response => {
          // Successfully logged in - pass the new token to the store
          commit('updateToken', response.key)
          resolve()
        },
        error => {
          // Could not login - to be safe, also remove any stored tokens (but this should not be possible)
          commit('removeToken')
          reject(error)
        })
      })
    },
    logout ({commit}) {
      return new Promise((resolve, reject) => {
        // Remove token from storage
        commit('removeToken')
        resolve()
      })
    },
    resetPassword ({commit}, params) {
      return new Promise((resolve, reject) => {
        auth.resetPassword({
          email: params.email
        },
        response => {
          // Successfully sent password reset
          resolve()
        },
        error => {
          // Could not reset password
          reject(error)
        })
      })
    },
    register ({commit}, params) {
      return new Promise((resolve, reject) => {
        auth.register({
          email: params.email,
          password: params.password,
          full_name: params.full_name
        },
        response => {
          // Successfully registered
          resolve()
        },
        error => {
          // Could not register
          reject(error)
        })
      })
    },
    confirmEmail ({commit}, params) {
      return new Promise((resolve, reject) => {
        auth.confirmEmail({
          key: params.key
        },
        response => {
          // Successfully confirmed email - pass the new token to the store
          commit('updateToken', response.token)
          resolve()
        },
        error => {
          // Could not confirm email
          reject(error)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js